import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, FeatureState } from './notification.reducer';

const featureSelector = createFeatureSelector<FeatureState>(featureKey);

export const selectCxbNotification = createSelector(featureSelector, (state) => ({
  message: state.message,
  color: state.color,
}));
